module.exports = {
  siteTitle: 'Bohdan Kutsenko',
  siteDescription:
    'Bohdan Kutsenko is an incoming Software Developer, based in India, who loves learning new things and helping tech beginners.',
  siteKeywords:
    'Bohdan Kutsenko, Bohdan, Kutsenko, bohdankutsenko, software engineer, web developer, javascript, python, java, svvv, indore',
  siteUrl: 'https://bohdankutsenko.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Bohdan Kutsenko',
  location: 'Indore, India',
  email: 'bohdan.workspace0@gmail.com',
  github: 'https://github.com/bohdankutsenko',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/bohdankutsenko',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/bohdan-kutsenko-b251aa2a9/',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/bohdankutsenko',
    // },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/bohdankutsenko',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/kutsenko_b90934',
    },
    {
      name: 'Facebook',
      url: 'https://facebook.com/bohdankutsenko',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
